import React, { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { User } from "lucide-react";

const ROLE_LABEL = {
  admin: "Administrator", doctor: "Mjek Stomatolog",
  receptionist: "Recepsionist", assistant: "Asistent",
};

export default function Profile() {
  const { user } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirmNext, setConfirmNext] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirmNext) {
      toast.error("Fjalëkalimet nuk përputhen");
      return;
    }
    if (next.length < 6) {
      toast.error("Fjalëkalimi duhet të ketë të paktën 6 karaktere");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", {
        current_password: current, new_password: next,
      });
      toast.success("Fjalëkalimi u përditësua me sukses");
      setCurrent(""); setNext(""); setConfirmNext("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setSaving(false); }
  };

  return (
    <div className="space-y-8 max-w-2xl" data-testid="profile-page">
      <div>
        <div className="label-eyebrow">Llogaria ime</div>
        <h1 className="mt-2 text-4xl font-semibold tracking-tight sm:text-5xl">Profili</h1>
        <p className="mt-2 text-sm text-[#5C5C5C]">Të dhënat tuaja dhe siguria e llogarisë.</p>
      </div>

      <div className="surface-card p-6">
        <div className="flex items-center gap-4">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#EAE4D9] text-[#2C4C3B]">
            <User size={22} />
          </div>
          <div>
            <div className="text-lg font-semibold">{user?.name}</div>
            <div className="text-sm text-[#5C5C5C]">{user?.email}</div>
            <div className="mt-1 inline-block rounded-full bg-[#2C4C3B] px-3 py-0.5 text-xs font-medium text-[#FDFBF7]">
              {ROLE_LABEL[user?.role]}
            </div>
          </div>
        </div>
      </div>

      <div className="surface-card p-6">
        <div className="label-eyebrow mb-1">Siguria</div>
        <h2 className="text-2xl font-semibold tracking-tight mb-4">Ndrysho Fjalëkalimin</h2>

        <form onSubmit={submit} className="space-y-4 max-w-md" data-testid="change-password-form">
          <div>
            <Label className="label-eyebrow">Fjalëkalimi Aktual</Label>
            <Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)}
                   required className="mt-2" data-testid="current-password-input" />
          </div>
          <div>
            <Label className="label-eyebrow">Fjalëkalimi i Ri</Label>
            <Input type="password" value={next} onChange={(e) => setNext(e.target.value)}
                   minLength={6} required className="mt-2" data-testid="new-password-input" />
          </div>
          <div>
            <Label className="label-eyebrow">Konfirmo Fjalëkalimin e Ri</Label>
            <Input type="password" value={confirmNext} onChange={(e) => setConfirmNext(e.target.value)}
                   minLength={6} required className="mt-2" data-testid="confirm-password-input" />
          </div>
          <button type="submit" disabled={saving} className="btn-primary" data-testid="change-password-button">
            {saving ? "Duke ruajtur…" : "Ruaj Fjalëkalimin"}
          </button>
        </form>
      </div>
    </div>
  );
}
